/**
 * ADD PERSON JS - SECTION 1B
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - inside / outside people array?
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Add Person UI, data
         * UI interaction functions
         */
        console.log( 'Add Person widgets - init' );
        
        this.aon_add_person_entries = [];
        
        var add_edit_person_modal_mode = '';
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_live' );
            
        } else { // If not Business Plan page then we are in 1B...
            if ( $( '#section_1b_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
    

        // Click on Add Person link...
        $( 'body' ).on( 'click', '.add_person', function( event ) {
            add_edit_person_modal_mode = 'add';
            //var name = $( this ).text();
            //var id = $( this ).attr( 'add_edit_person_id' );
            var list_id = $( this ).parents( '.inside_outside_relationships' ).attr( 'id' );
            if ( $( this ).parents( '.column' ).hasClass( 'inside' ) ) {
                var position = 'inside';
            } else if ( $( this ).parents( '.column' ).hasClass( 'outside' ) ) {
                var position = 'outside';
            }
            
            $( '#add_edit_a_person_modal #add_edit_person_name' ).val( '' );
            $( '#add_edit_a_person_modal #add_edit_person_id' ).val( '' );
            $( '#add_edit_a_person_modal #add_edit_person_position' ).val( position );
            $( '#add_edit_a_person_modal #add_edit_person_list_id' ).val( list_id );
            
            // Open Modal...
            $( '#add_edit_a_person_modal' ).foundation( 'open' );
            
            event.preventDefault();
        });
        
        // Click on Edit Person link...
        $( 'body' ).on( 'click', '.edit_person', function( event ) {
            add_edit_person_modal_mode = 'edit';
            var name = $( this ).text();
            var id = $( this ).attr( 'data-person-id' );
            var list_id = $( this ).attr( 'data-person-list_id' );
            var position = $( this ).attr( 'data-person-position' );
            
            $( '#add_edit_a_person_modal #add_edit_person_name' ).val( name );
            $( '#add_edit_a_person_modal #add_edit_person_id' ).val( id );
            $( '#add_edit_a_person_modal #add_edit_person_position' ).val( position );
            $( '#add_edit_a_person_modal #add_edit_person_list_id' ).val( list_id );
            
            // Open Modal
            $( '#add_edit_a_person_modal' ).foundation( 'open' );
            
            event.preventDefault();
        });
    
        

        // 'Save' button click within add / edit person modal...
        $( 'body' ).on( 'click', '#save_add_edit_person', function( event ) {
            // Save data to existing
            var id = $( '#add_edit_a_person_modal #add_edit_person_id' ).val();
            var name = $( '#add_edit_a_person_modal #add_edit_person_name' ).val();
            var position = $( '#add_edit_a_person_modal #add_edit_person_position' ).val();
            var list_id = $( '#add_edit_a_person_modal #add_edit_person_list_id' ).val();
            if ( add_edit_person_modal_mode == 'edit') {
                // Update existing entry to entries array - if req values all complete...
                if ( id != '' && name != '' && position != '' && list_id != '' ) {
                    saveExistingPersonEntry( id, name, position, list_id );
                }
            } else if ( add_edit_person_modal_mode == 'add' ) {
                // Add new entry to entries array - if req values all complete...
                if ( name != '' && position != '' && list_id != '' ) {
                    saveNewPersonEntry( name, position, list_id );
                }
            } else if ( add_edit_person_modal_mode == 'delete' ) {
                // Delete...
                deletePersonEntry( id );
            }
            
            event.preventDefault();
        });
        
        var saveExistingPersonEntry = ( id, name, position, list_id ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_add_person_entries[ id ][ 'name' ] = aon_craft_utils.removeHTMLTags( name );
            this.aon_add_person_entries[ id ][ 'position' ] = aon_craft_utils.removeHTMLTags( position );
            this.aon_add_person_entries[ id ][ 'list_id' ] = list_id;
            this.renderPeopleEntries();
            $( '#add_edit_a_person_modal' ).foundation( 'close' );
        }
        
        var saveNewPersonEntry = ( name, position, list_id ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_add_person_entries.push( { name: aon_craft_utils.removeHTMLTags( name ), position: aon_craft_utils.removeHTMLTags( position ), list_id: list_id } );
            this.renderPeopleEntries();
            $( '#add_edit_a_person_modal' ).foundation( 'close' );
        }
        
        var deletePersonEntry = ( id ) => {
            this.aon_add_person_entries.splice( id, 1 );
            this.renderPeopleEntries();
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#add_edit_a_person_modal' ).foundation( 'close' );
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
            $( '#save_add_edit_person ').text( save_text ); // Save
            $( '#save_add_edit_person ').removeClass( 'delete' );            
        }
        
        /*
         * MODAL Delete / Normal button states
         */
        $( 'body' ).on( 'change', '#delete_entry', function( event ) {
            if ( $( '#delete_entry' ).prop( 'checked' ) ) {
				//var save_text = $( '.modal_save_text' ).val();
				var delete_text = $( '.modal_delete_text' ).val();
                $( '#save_add_edit_person ').text( delete_text ); // DELETE
                $( '#save_add_edit_person ').addClass( 'delete' );
                add_edit_person_modal_mode = 'delete';
                console.log( 'DELETE' );
            } else {
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
                $( '#save_add_edit_person ').text( save_text ); // Save
                $( '#save_add_edit_person ').removeClass( 'delete' );
                add_edit_person_modal_mode = 'edit';
                console.log( 'NOT DELETE' );
            }
            event.preventDefault();
        });
        
        // Add / Edit Entry modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#add_edit_a_person_modal', function() {
            if ( add_edit_person_modal_mode == 'edit') {
                $( '.edit', this ).show();
                $( '.add', this ).hide();
                $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
                $( '#save_add_edit_person ').text( save_text ); // Save
                $( '#save_add_edit_person ').removeClass( 'delete' );
                $( '.delete_entry_panel', this ).show();
            } else if ( add_edit_person_modal_mode == 'add' ) {
                $( '.edit', this ).hide();
                $( '.add', this ).show();
                $( '#add_edit_person_name' ).val( '' );
                $( '#add_edit_person_id' ).val( '' );
                $( '.delete_entry_panel', this ).hide();
            }
            $( '#add_edit_person_name' ).focus();
            //console.log( 'add_edit_a_person_modal open' );
        });

        // Add / Edit Entry modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#add_edit_a_person_modal', function() {
            $( '#add_edit_person_name' ).val( '' );
            $( '#add_edit_person_id' ).val( '' );
            $( '#add_edit_person_position' ).val( '' );
            $( '#add_edit_person_list_id' ).val( '' );
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_add_edit_person ').text( save_text ); // Save
            $( '#save_add_edit_person ').removeClass( 'delete' );
            //console.log( 'add_edit_a_person_modal close' );
        });
        
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });

        

    },
    
    renderPeopleEntries() {
        // Get any existing saved entry data...
        //this.loadData( 'start' );
        
        // Clear existing entries before re-loading...
        $( '.inside_outside_relationships .people li' ).remove();
        $( '.inside_outside_relationships_stacked .people li' ).remove();
        
        // Loop over entries array...
        var entry_count = 1;
        $.each( this.aon_add_person_entries, function( index ) {
            // Begin entry...            
            var aon_add_person_item = '<a href="#edit_person" data-person-id="' + index + '" data-person-position="' + this.position + '" data-person-list_id="' + this.list_id + '" class="edit_person"><span class="person_name">' + this.name + '</span></a>';
            $( '#' + this.list_id + ' div.' + this.position + ' .people' ).append( '<li>' + aon_add_person_item + '</li>' );
            $( '#' + this.list_id + '_results div.' + this.position + ' .people' ).append( '<li>' + aon_add_person_item + '</li>' );
            entry_count++;
        });  
    },

    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_1b_data_json = $( '#section_1b_data_json' ).val();
            this.aon_add_person_entries = JSON.parse( aon_section_1b_data_json );
            console.table( this.aon_add_person_entries );
            this.renderPeopleEntries();
            
        } else if ( mode == 'load_demo' ) {
            // Using temp JSON source for now...
            var aon_add_person_entries_json = '[';
                aon_add_person_entries_json += '{"name":"Mr Constantine","position":"inside","list_id":"add_a_person_products_services"},';
                aon_add_person_entries_json += '{"name":"Jimmy","position":"inside","list_id":"add_a_person_products_services"},';
                aon_add_person_entries_json += '{"name":"Mr Constantine","position":"inside","list_id":"add_a_person_products_services"},';
                aon_add_person_entries_json += '{"name":"Mr Constantine","position":"inside","list_id":"add_a_person_products_services"},';
                aon_add_person_entries_json += '{"name":"Meredith","position":"inside","list_id":"add_a_person_products_services"},';
                aon_add_person_entries_json += '{"name":"Mr Constantine","position":"inside","list_id":"add_a_person_products_services"},';
                aon_add_person_entries_json += '{"name":"Mickey","position":"inside","list_id":"add_a_person_products_services"},';
                aon_add_person_entries_json += '{"name":"Bernard","position":"outside","list_id":"add_a_person_products_services"},';
                aon_add_person_entries_json += '{"name":"Hector","position":"outside","list_id":"add_a_person_management_administration"},';
                aon_add_person_entries_json += '{"name":"Ezmerelda","position":"inside","list_id":"add_a_person_marketing_distributing"},';
                aon_add_person_entries_json += '{"name":"Peter","position":"outside","list_id":"add_a_person_customers_clients"},';
                aon_add_person_entries_json += '{"name":"Billy-bob","position":"inside","list_id":"add_a_person_others"}';
                aon_add_person_entries_json += ']';

            this.aon_add_person_entries = JSON.parse( aon_add_person_entries_json );
            this.renderPeopleEntries();
            
        } else if ( mode == 'start' ) {

            // No need for default data setting here as it is handled
            // in the add_person_entries code already.
            
        }
        
        console.table( this.aon_add_person_entries );
     
    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        var jsonDataString = JSON.stringify( this.aon_add_person_entries );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '1B - ADD PERSON - AJAX - START' );
        var meta = { 'section_1b_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '1B - ADD PERSON - AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_add_person_entries );
    }
}